import React from "react";
import Select from "react-select";

export default function RegulationsDropdown({ values, handleChange }) {
  const regulationDropdownOptions = [{ label: "DLT", value: "DLT" }];

  const regulationDropdownSelectedValues = values.map((selectedRegulation) => {
    return regulationDropdownOptions.find((regulationOption) => regulationOption.value === selectedRegulation);
  });

  return (
    <Select
      placeholder="Regulations"
      value={regulationDropdownSelectedValues}
      options={regulationDropdownOptions}
      onChange={(values) => {
        const tempValue = values ? values.map((v) => v.value) : [];
        handleChange(tempValue);
      }}
      isMulti
    />
  );
}
